import React from 'react';

const RegulatoryForm = () => {
    return (
        <div>
            Regulatory Form
        </div>
    );
};

export default RegulatoryForm;